<template>
  <div class="signUp">
    <svg xmlns="http://www.w3.org/2000/svg">
      <!-- filterUnits is required to prevent clipping the blur outside the viewBox -->
      <filter id="motion-blur-filter" filterUnits="userSpaceOnUse">
        <!-- We only want horizontal blurring. x: 100, y: 0 -->
        <feGaussianBlur stdDeviation="25 0"></feGaussianBlur>
      </filter>
    </svg>
    <vue-typed-js
      :strings="[
        ', <br /> if this is your first time hiring a site, <br /> fill out the form and sign up',
        '<br /> if you are already registered with us, <br /> go to sign in page and signin'
      ]"
      v-if="$vuetify.breakpoint.lgAndUp"
      :loop="true"
      :typeSpeed="100"
      :backSpeed="25"
      :contentType="'html'"
      style="align-self: flex-start; margin: 8%;"
    >
      <h1 class="typed_text" filter-content="W">
        Welcome, glad to see you
        <span class="typing"></span>
      </h1>
    </vue-typed-js>
    <v-flex xs12 sm6 md4 lg3 class="signUp_container">
      <div class="signUp_form">
        <div class="signUp_form-title mb-2">
          Sign up
        </div>
        <transition name="fade">
          <!--Error Alert-->
          <!-- <form-alert style="width: 95%;" v-if="error" :message="error.message">
          </form-alert> -->
        </transition>
        <v-form
          v-model="isFormValid"
          lazy-validation
          ref="form"
          @submit.prevent="handleSignupUser"
          class="signUp_form-flex"
        >
          <v-text-field
            :rules="userEmailRules"
            style="width: 100%;"
            autocomplete="email"
            v-model.trim="userEmail"
            label="Email"
            prepend-inner-icon="mail"
            placeholder="Enter your email"
            type="text"
            required
            outlined
            dark
          ></v-text-field>
          <v-text-field
            :rules="userNameRules"
            style="width: 100%;"
            autocomplete="name"
            v-model.trim="userName"
            label="User name"
            prepend-inner-icon="account_circle"
            placeholder="Enter your name"
            type="text"
            outlined
            dark
          ></v-text-field>
          <v-select
            style="width: 100%;"
            v-model="gender"
            outlined
            cy-data="gender_dropdown"
            :items="['male', 'female', 'intersex']"
            label="Gender"
            :rules="requiredRule"
            prepend-inner-icon="face"
            :menu-props="{ contentClass: 'gender-dropdown-in' }"
            dark
          ></v-select>
          <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="250px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                outlined
                dark
                style="width: 100%;"
                cy-data="birthdate-selector-txt"
                v-model="birthDate"
                label="Birth Date"
                :rules="requiredRule"
                prepend-inner-icon="event"
                v-on="on"
                v-bind="attrs"
                readonly
                :menu-props="{ contentClass: 'birthdate-selector' }"
              ></v-text-field>
            </template>
            <v-date-picker
              :menu-props="{ contentClass: 'birthday-datepicker' }"
              v-model="birthDate"
              @input="menu = false"
            ></v-date-picker>
          </v-menu>
          <v-text-field
            style="width: 100%;"
            :rules="passwordRules"
            v-model.trim="password"
            label="Password"
            autocomplete="new-password"
            placeholder="Enter your password"
            :type="showPass ? 'text' : 'password'"
            :append-icon="showPass ? 'fa-eye' : 'fa-eye-slash'"
            prepend-inner-icon="fa-lock"
            required
            outlined
            dark
            @click:append="showPass = !showPass"
          >
          </v-text-field>
          <v-text-field
            style="width: 100%;"
            :rules="passwordRules"
            v-model.trim="passwordConfirmation"
            label="Confirm Password"
            autocomplete="confirm-password"
            placeholder="Confirm your password"
            :type="showConfirmPass ? 'text' : 'password'"
            :append-icon="showConfirmPass ? 'fa-eye' : 'fa-eye-slash'"
            required
            outlined
            prepend-inner-icon="gavel"
            dark
            @click:append="showConfirmPass = !showConfirmPass"
          >
          </v-text-field>
          <v-flex xs12>
            <div class="signUp_form-confirm-rule">
              By marking checkboxes and Signing-up you confirm that you've read
              and agreed on
              <a href="../../SportEcoSysPrivacyPolicy.pdf" target="_blank">
                SportEcoSysPrivacyPolicy
              </a>
              and
              <a href="../../SportEcoSysTermsOfService.pdf" target="_blank">
                SportEcoSysTermsOfService
              </a>
            </div>
          </v-flex>
          <v-checkbox
            dark
            id="checkboxOG"
            style="align-self: flex-start"
            v-model="privacyPolicy"
            label="SportEcoSysPrivacyPolicy"
          ></v-checkbox>
          <v-checkbox
            dark
            id="checkbox-TermsOfService"
            style="align-self: flex-start"
            v-model="privacyTermsOfService"
            label="SportEcoSysTermsOfService"
          ></v-checkbox>
          <v-btn
            outlined
            color="white"
            :disabled="!isFormValid || loading"
            type="submit"
            style="width: 100%;"
            :loading="loading"
            data-cy="signUpButton"
          >
            Sign Up
          </v-btn>
          <h3 class="helper_text">
            Alredy have an account?
            <router-link to="/auth/signin">Sign In</router-link>
          </h3>
        </v-form>
      </div>
    </v-flex>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { validationRules } from "../../../constants/global";

export default {
  data() {
    return {
      showPass: false,
      showConfirmPass: false,
      menu: false,
      userEmail: "",
      birthDate: "",
      privacyPolicy: false,
      privacyTermsOfService: false,
      gender: "",
      role: "",
      password: "",
      passwordConfirmation: "",
      userName: "",
      isFormValid: true,
      userNameRules: validationRules.name,
      userEmailRules: validationRules.email,
      requiredRule: validationRules.required,
      passwordRules: [
        password => !!password || "Password is required",
        password =>
          password.length >= 4 || "Password must be at least 4 characters",
        confirmation => confirmation === this.password || "Passwords must match"
      ]
    };
  },

  computed: {
    ...mapGetters(["loading", "error", "user"])
  },

  watch: {
    user(value) {
      if (value) {
        this.$router.push("/landing");
      }
    }
  },
  methods: {
    handleSignupUser() {
      if (this.$refs.form.validate()) {
        this.$store.dispatch("signUpUser", {
          userName: this.userName,
          userEmail: this.userEmail,
          password: this.password,
          birthDate: this.birthDate,
          gender: this.gender,
          createDate: new Date().toISOString().substr(0, 10),
          role: this.role ? this.role : "user",
          updateSource: "SportEcoSysApp"
        });
      }
    }
  }
};
</script>

<style lang="scss">
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}

.typed_text {
  font-size: 30px;
  font-weight: 900;
  font-family: "Roboto";
  font-style: italic;
  color: white;
  text-transform: uppercase;
}
.typed_text::before {
  content: attr(filter-content);
  filter: url(#motion-blur-filter);
}

svg {
  display: none;
}

.signUp {
  width: 100%;
  height: 100%;
  background-image: url("../../../../public/assets/img/pool-wallpaper-12.jpeg");
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  overflow: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;

  &_container {
    height: 100%;
    background-color: #0277bd;
    display: flex;
    align-items: center;
    opacity: 0.9;
    border-left: 1px solid white;
  }

  &_form {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    width: 100%;
    padding: 5% 2.5%;
    margin: 0 auto;
  }

  &_form-confirm-rule {
    color: white;

    a {
      color: black;
      text-decoration: none;
    }
  }

  &_form-title {
    font-size: 40px;
    font-weight: bold;
    color: white;
    align-self: flex-start;
    margin-left: 2.5%;
    font-family: "Roboto";
  }

  &_form-flex {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    /* Change the white to any color */
    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    input:-webkit-autofill:active {
      -webkit-text-fill-color: white;
      -webkit-box-shadow: 0 0 0 30px #0277bd inset !important;
    }

    input:focus,
    input:active {
      color: white !important;
    }
  }

  &_form-email {
    width: 100%;
  }

  &_form-pass {
    width: 100%;
  }
}

.helper_text {
  color: white;
  font-weight: normal;
  margin: 10px auto;

  a {
    color: white;
    padding-left: 10px;
    margin-left: 10px;
    text-decoration: none;
    border-left: 1px solid white;
    transition: all 0.1s;
  }

  a:hover {
    text-shadow: 0 0 1px white;
    border: 1px solid white;
    padding: 3px 8px;
  }
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@media only screen and (max-width: 1264px) {
  .signUp {
    justify-content: flex-end;
  }
}

@media only screen and (max-width: 599px) {
  .signUp_container {
    border: none;
  }
}
</style>
